const AthenaIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`tabler-icon tabler-icon-math-greater -rotate-90 ${className}`}
    >
      <path d="M5 18l14 -6l-14 -6"></path>
    </svg>
  )
}

export default AthenaIcon
